import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step1 } from '../../../../shared/models/component-messages/simp_in/step1';
import { RadioCheckBoxEnum } from '../../../common/radio.checkbox.enums';
import { DocSecurite } from '../models/DocSecurite';
import { Non } from '../models/Non';
@Component({
	selector: 'app-doc-securite',
	templateUrl: './doc-securite.component.html'
})
export class DocSecuriteComponent implements OnInit {
	@Input() uid = '';
	public current_uid = 'DocSecurite';
	@Input() parentForm: FormGroup;

	@Input() disabled: boolean;
	@Input() docSecurite: DocSecurite;

	public step1 = new Step1();

	constructor() {}

	public ngOnInit() {
		if ((this.docSecurite.oui === RadioCheckBoxEnum.emptyValue || this.docSecurite.oui === 'Oui') && this.docSecurite.non == null) {
			this.docSecurite.oui = RadioCheckBoxEnum.ouiValue;
		}
		else if (this.docSecurite.non) {
			this.docSecurite.oui = RadioCheckBoxEnum.nonValue;
		}
		else {
			this.docSecurite.oui = RadioCheckBoxEnum.emptyValue;
		}
	}

	isDocSecuriteNon() {
		if (this.parentForm.controls[this.getUid() + '_SepAtt_oui'].value === 'Non') {
			if (!this.docSecurite.non) {
				this.docSecurite.non = new Non();
			}
			return true;
		}
	
		this.docSecurite.non = null;
		return false;
	}

	getUid() {
		return this.uid + '_SepSep_' + this.current_uid;
	}
}
